// Components/ui
import { Body } from './components';
import { SubsectionHeader } from '..';
// Types
import { Box } from '@mui/material';
import UseEditBusiness from '../../../../../../../hooks/useEditBusiness/types/UseEditBusiness';
import UseEditContact from '../../../../../../../hooks/useEditContact/types/UseEditContact';
import { IContactAddress } from '@trii/types/dist/Contacts';
import { NewAddress } from '../../../../../../../utils/contactHelper';

type Props = {
  editEntity: UseEditBusiness | UseEditContact;
  title: string;
  IMSs: IContactAddress[] | NewAddress[];
};

const InformationSocialNetworkItem = ({ editEntity, title, IMSs }: Props) => {
  return (
    <Box sx={{ width: '100%' }}>
      <SubsectionHeader title={title} />
      <Body IMSs={IMSs} editEntity={editEntity} />
    </Box>
  );
};

export default InformationSocialNetworkItem;
